import TagManager from 'react-gtm-module';

import HomePageViewEvent from '@models/googleAnalytics/homePageViewEvent';
import HomePageViewProps from '@models/googleAnalytics/homePageViewProps';
import LinkClickEventProps from '@models/googleAnalytics/linkClickEventProps';
import LinkClickPageEvent from '@models/googleAnalytics/linkClickPageEvent';
import QaEvent from '@models/googleAnalytics/qaEvent';
import QaEventProps from '@models/googleAnalytics/qaEventProps';

const events: Record<string, QaEvent> = {
  homePageView: new HomePageViewEvent(),
  linkClick: new LinkClickPageEvent()
};

function sendQaEvent(eventName: 'homePageView', eventCustomProps: HomePageViewProps): void;
function sendQaEvent(eventName: 'linkClick', eventCustomProps: LinkClickEventProps): void;
function sendQaEvent(eventName: string, eventCustomProps: QaEventProps): void {
  const event = events[eventName];
  TagManager.dataLayer({
    dataLayer: event.getEvent(eventCustomProps)
  });
}

export default sendQaEvent;
